import styled from 'styled-components';

interface DownloadStatusProps {
	isRowView: boolean;
}

const DownloadStatus = styled('div')`
	${(props: DownloadStatusProps) => props.isRowView
		? `
			display: block;
			position: absolute;
			bottom: 18px;
		`
		: `
			display:inline-block;
			margin-left: 10px;
		`
	}

	> svg {
		vertical-align: bottom;
		width: 14px;
		height: 14px;
	}
`;

export { DownloadStatus };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/DownloadStatus/styles.ts